import { Services, joinURLPath, projectName } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { macroCacheOptions, request } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)
const cachedGet = Cache.wrapWithCache(async (key, service, id) => {
  return await request.get(joinURLPath(service, id))
})

export default {
  name: 'ServicesValue',

  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    count: {
      type: Number,
      default: 2
    },
    service: {
      type: String
    }
  },

  data() {
    return {
      loading: false,

      proxy: []
    }
  },

  computed: {
    countTooltip() {
      return this.proxy.reduce((result, item, index) => {
        if (index < 20) {
          result.push(item.title)
        }

        return result
      }, []).join('\n')
    },

    isMany() {
      return this.value.length > this.count
    },

    name() {
      let service = this.service
      if (this.service === 'contactLists') {
        service = Services.contacts
      }

      return `${service}.single`
    }
  },

  mounted() {
    this.fillData()
  },

  methods: {
    async fillData() {
      this.loading = true

      for (const item of this.value) {
        const result = {
          id: undefined,
          title: undefined
        }
        if (typeof item === 'string') {
          result.id = item
        } else if (item && typeof item === 'object') {
          result.id = item.id
          result.title = item.title
        }
        if (!result.title) {
          const key = [ projectName, this.service, 'get', result.id ].join(':')
          const response = await cachedGet(key, this.service, result.id)
          if (response) {
            result.title = response.title
          }
        }

        this.proxy.push(result)
      }

      this.loading = false
    }
  },

  render
}
